/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const AgentAcceptSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 12 13"
  >
    <path
      fill="currentColor"
      d="M10.206 9.136a5.76 5.76 0 00-1.647-1.1c.863-.668 1.414-1.688 1.414-2.832 0-2.019-1.761-3.675-3.874-3.644-2.08.031-3.756 1.65-3.756 3.644 0 1.144.553 2.164 1.415 2.832a5.748 5.748 0 00-1.648 1.1c-1.04.997-1.632 2.312-1.67 3.715a.14.14 0 00.043.105.153.153 0 00.11.044H1.66c.082 0 .15-.062.153-.14a4.032 4.032 0 011.272-2.796 4.339 4.339 0 011.41-.903 4.497 4.497 0 011.665-.314c1.161 0 2.254.431 3.075 1.217a4.049 4.049 0 011.272 2.796c.002.078.07.14.153.14h1.067a.16.16 0 00.11-.044.145.145 0 00.043-.105c-.038-1.403-.63-2.718-1.674-3.715zm-4.046-1.6a2.478 2.478 0 01-1.726-.684 2.307 2.307 0 01-.535-.766 2.22 2.22 0 01-.18-.906 2.283 2.283 0 01.693-1.603 2.487 2.487 0 011.723-.705 2.516 2.516 0 011.735.667c.473.442.732 1.034.732 1.665 0 .623-.253 1.207-.715 1.648-.226.217-.495.39-.792.507a2.526 2.526 0 01-.935.176z"
    ></path>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.36 5.2v1.04h-1.04v-.898a7.2 7.2 0 01-.96.885c-.765.578-1.78 1.04-2.79.604a.88.88 0 01-.357.026c-.316-.038-.56-.214-.543-.393.017-.18.227-.363.543-.325.316.038.62.283.603.462a.187.187 0 01-.007.036c.85.293 1.706-.09 2.406-.62.41-.31.758-.663 1.003-.94l.102-.117v-.8h.404a4.682 4.682 0 00-9.128 0H2v2.08H.96V4.16h.104a5.202 5.202 0 0110.192 0h.104V5.2z"
      clipRule="evenodd"
    ></path>
  </svg>
);

export const AgentAcceptIcon = props => <Icon component={AgentAcceptSvg} {...props} />;

